import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const PoliciesStore = WithErrorBoundary(
  'Políticas',
  'Error en Políticas de Comisiones',
  React.lazy(() => import('./policies/Policies.store'))
)


const ListPoliciesStore = WithErrorBoundary(
  'Políticas',
  'Error en lista de políticas',
  React.lazy(() => import('./ListPolicies/ListPolicies.store')),
)

const ListCommissionsContainer = WithErrorBoundary(
  'Comisiones',
  'Error en lista de comisiones',
  React.lazy(() => import('./ListCommissions/ListCommissions.container')),
)

export default {
  path: '/comisiones',
  name: 'Comisiones',
  childRoutes: [
    {
      path: 'politicas/crear',
      name: 'Políticas de comisiones',
      component: PoliciesStore,
      isIndex: true
    },
    { 
      path: 'politicas/editar/:id', 
      name: 'editar', 
      component: PoliciesStore 
    },
    {
      path:'politicas',
      name:'Políticas de comisiones',
      component: ListPoliciesStore,
      isIndex: true
    },
    {
      path:'lista',
      name:'Lista de comisiones',
      component: ListCommissionsContainer,
      isIndex: true
    },
    {
      path: 'politicas/ver/:id',
      name: 'Políticas de comisiones',
      component: PoliciesStore,
      isIndex: true
    },
  ]
  
}
